module.exports = __webpack_public_path__ + "img/waze.25b6ebac.png";